<div class="sso-error-page">
  <a href="mailto:exchange.support@lmax.com" class="mail-support"
    >exchange.support&#64;lmax.com</a
  >
</div>
